module.exports = __webpack_public_path__ + "static/plants-a5439fdbc3be458cc01ed6f7f07f223b.jpg";